<template lang="pug">
  div
    h3 CoD Chatlogs
    table(cellspacing="0", cellpadding="0" v-if="logs && logs.length > 0")
      tr
        th ID&nbsp;
          span.mobile-hide(@click="updateFilter('ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('DESC')").filter.desc #[menu-down-icon]
        th Client ID
        th.mobile-hide Name
        th Message
        th Time

      tr(v-for="log of logs")
        td {{ log.id }}
        td {{ log.client_id }}
        td.mobile-hide {{ log.client_name }}
        td.message {{ log.msg }}
        td {{ log.msg_time | unixDate }}

    p(v-else) No logs available for this server. (Blame @atrx for not setting it up yet)
</template>

<script>
import MenuUpIcon from 'vue-material-design-icons/MenuUp.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';

export default {
  name: 'cod-chatlog',
  props: [
    'logs',
    'updateFilter',
  ],
  components: {
    MenuUpIcon,
    MenuDownIcon,
  },
};
</script>

<style lang="scss" scoped>
  .message {
    width: auto;
    max-width: 500px;
    word-wrap: break-word;
  }
</style>
